<template>
  <fragment>
    <c-generic-section top-divider v-if="disabled">
      <div class="container-xs">
        <h2 class="mt-0">Oops, this payment link is not currently active.</h2>
        <p
          class="strong"
        >This page lets you make a single one-off payment, but it is not currently enabled.</p>
        <p>
          Please
          <a href="mailto:dima@mvpforsaas.com">contact Dima</a>.
        </p>
      </div>
    </c-generic-section>
    <c-generic-section top-divider v-else>
      <div class="container-xs">
        <h2 class="mt-0">Get the next phase of your Professional MVP project scheduled by making a payment.</h2>
        <p class="strong">This page lets you make a single one-off payment for <span v-html="amounts[0]"></span></p>
        <p>You're seeing this page after our Micro MVP work together, during which we communicated comfortably, built something real, and established a close working relationship. Now it's time to get the full-scale MVP out for {{companyName}}.</p>
        <p></p>
        <p>Your payment guarantees the following:</p>
        <ul>
          <li>During our work, you'll receive regular status updates.</li>
          <li>
            I
            <router-link to="/guarantee">guarantee all my work</router-link>
            . I'll be available to you after the project is delivered for additional projects, or to provide ongoing support for {{companyName}}.
          </li>
          <li>Our work is contingent on agreeing what does & does not go into an MVP. As you know, most features are "nice to have". We're going to focus on "need to have", and you can expect me to challenge you on that question throughout the process.</li>
        </ul>

        <CButton
          tag="button"
          wide
          color="primary"
          @click="redirectToCheckout"
          :loading="loading"
          :disabled="loading"
        >Checkout Now</CButton>
        <ul class="small no-bullets">
          <li>🔒 This payment link is secured by Stripe's bank-grade AES-256 encryption.</li>
          <li>Submitting this payment cements your project on my project calendar.</li>
          <li>As soon as this payment goes through, you will receive a receipt in your inbox.</li>
        </ul>
      </div>
    </c-generic-section>
  </fragment>
</template>

<script>
// import layout
import CLayout from "@/layouts/LayoutAlternative.vue";
// import section header
// import sections
import CGenericSection from "@/components/sections/GenericSection.vue";
import CButton from "@/components/elements/Button.vue";
import { loadStripe } from "@stripe/stripe-js";
const stripePromise = loadStripe("pk_live_56ysX32MWcIijXt0kBWJJrL2");
// const stripePromise = loadStripe("pk_test_5brbcIWHvtiDTXoVI0QW4a7X");
export default {
  name: "ProjectPaymentMicro",
  components: {
    CGenericSection,
    CButton,
  },
  data() {
    return {
      disabled: false,
      loading: false,
      amounts: ["$6,600&nbsp;USD"],
      priceItems: ["price_1IHAbOLWT1UWxE2Vp5SkA5KY"],
      option: 1
    };
  },
  created() {
    this.$emit("update:layout", CLayout);
  },
  computed: {
    companyName() {
      if (this.$route && this.$route.query.company)
        return this.$route.query.company;
      return "your business";
    },
  },
  methods: {
    async redirectToCheckout() {
      this.loading = true;
      const stripe = await stripePromise;
      const response = await fetch("/.netlify/functions/stripe-checkout", {
        method: "POST",
        body: JSON.stringify({priceItem: this.priceItems[parseInt(this.option)-1]})
      });

      const session = await response.json();

      // When the customer clicks on the button, redirect them to Checkout.
      const result = await stripe.redirectToCheckout({
        sessionId: session.id,
      });

      return result
    },
  },
};
</script>


<style lang="scss" scoped>
.strong {
  font-weight: bold;
}

ul.small {
  margin-top: 1rem;
}

.text-center {
  text-align: center;
}

ul.no-bullets {
  padding-left: 0;
}

ul.no-bullets li {
  margin-left: 0;
  list-style: none;
}
ul.small li {
  margin-top: 0.75rem;
  margin-bottom: 0rem;
  line-height: 1.5;
}
.small {
  font-size: 75%;
}

a{border-bottom:1px solid;}
</style>